import { render, staticRenderFns } from "./ControlBar.vue?vue&type=template&id=736534a6&"
import script from "./ControlBar.vue?vue&type=script&lang=ts&"
export * from "./ControlBar.vue?vue&type=script&lang=ts&"
import style0 from "./ControlBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/p00353_hh-ballett/client-player/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('736534a6')) {
      api.createRecord('736534a6', component.options)
    } else {
      api.reload('736534a6', component.options)
    }
    module.hot.accept("./ControlBar.vue?vue&type=template&id=736534a6&", function () {
      api.rerender('736534a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ControlBar.vue"
export default component.exports